import { render, staticRenderFns } from "./ViewFieldsModal.vue?vue&type=template&id=13811455"
import script from "./ViewFieldsModal.vue?vue&type=script&lang=js"
export * from "./ViewFieldsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports